import {
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
} from '@mui/material';
import React, { useState } from 'react';
import { TriState } from '../../types/TriState';
import { SavedVarderingarTableRow } from './SavedVarderingarTableRow';
import { BostadsvarderingDto } from '../../types/dtos/VarderingarModel';

const createEmptyRows = (
  page: number,
  rowsPerPage: number,
  rowCount = 0,
  rowHeight = 33
): JSX.Element => {
  const numEmptyRows = Math.max(0, (1 + page) * rowsPerPage - rowCount);
  return numEmptyRows > 0 ? (
    <TableRow style={{ height: rowHeight * numEmptyRows }}>
      <TableCell colSpan={4} />
    </TableRow>
  ) : (
    <></>
  );
};

interface SavedVarderingarTableProps {
  savedVarderingar: BostadsvarderingDto[];
  handleSelectAll: (checked: boolean) => void;
  selected: BostadsvarderingDto[];
  setActiveBostadsvardering: (bostadsvardering: BostadsvarderingDto) => void;
  activeBostadsvardering: BostadsvarderingDto;
  toggleRowSelect: (bostadsvardering: BostadsvarderingDto) => void;
}

export const SavedVarderingarTable: React.FC<SavedVarderingarTableProps> = ({
  savedVarderingar,
  handleSelectAll,
  selected,
  setActiveBostadsvardering,
  activeBostadsvardering,
  toggleRowSelect,
}) => {
  const [page, setPage] = useState(0);

  const rowsPerPage = 15;
  const numSelected = selected?.length || 0;
  const selectionState =
    numSelected > 0 && numSelected < savedVarderingar.length
      ? TriState.Mixed
      : savedVarderingar.length > 0 && numSelected === savedVarderingar.length
      ? TriState.True
      : TriState.False;

  return (
    <TableContainer>
      <Table size="small" sx={{ minWidth: 750 }}>
        <TableHead>
          <TableRow>
            <TableCell padding="checkbox">
              <Checkbox
                indeterminate={selectionState === TriState.Mixed}
                checked={selectionState === TriState.True}
                onChange={(e) => handleSelectAll(e.currentTarget.checked)}
              />
            </TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Adress</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Senast uppdaterad</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Kundmärke</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {savedVarderingar
            .sort((a, b) =>
              new Date(a.uppdateradTidpunkt) < new Date(b.uppdateradTidpunkt)
                ? 1
                : -1
            )
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row) => (
              <SavedVarderingarTableRow
                selectBostadsvardering={setActiveBostadsvardering}
                handleCheckboxClick={toggleRowSelect}
                isItemSelected={selected.some((t) => t.id === row.id)}
                isItemActive={activeBostadsvardering?.id === row.id}
                rowData={row}
                key={row.id}
              />
            ))}
          {createEmptyRows(page, rowsPerPage, savedVarderingar?.length)}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              page={page}
              rowsPerPage={rowsPerPage}
              count={savedVarderingar.length}
              onPageChange={(_e, newPage) => setPage(newPage)}
              rowsPerPageOptions={[rowsPerPage]}
              labelDisplayedRows={(p) => (
                <span>
                  Visar {p.from} - {p.to} av {p.count}
                </span>
              )}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};
